import { KeyValuePair } from './KeyValuePair';
import { BaseSensor } from './BaseSensor';
import { ISensorInterface } from './ISensorInterface';
import { HeatingCircuit } from './HeatingCircuit';
import { ZoneData } from './ZoneData';
import { Device } from './Device';
import { SimulatorConfig } from './SimulatorConfig';
import { SimulatorHooks } from './SimulatorHooks';
import { TranslationService } from '../services/translation.service';
export class DeviceInfo extends Device {

	private _debug: boolean = false;
	private debug(msg: string) {
		if (this._debug) {
			console.log("DeviceInfo: " + msg);
		}
	}
	_hooks: SimulatorHooks;
	mode: string = "";
	heatpumpCount = 0;
	modes: Map<string, string>;

	states: Map<string, string>;
	_brightness: BaseSensor;

	private defaultZone: number;
	private zoneData = new Array<ZoneData>();
	private heatingCircuits = new Array<HeatingCircuit>();

	// zahlenwerte, die mit bestimmter schrittweite in einem bestimmten bereich liegen.
	scales: Map<string, BaseSensor>;
	constructor() {

		super(0);
		this._hooks = new SimulatorHooks(this);
		this.states = new Map<string, string>();
		this.modes = new Map<string, string>();
		this.scales = new Map<string, BaseSensor>();
		for (let mode of this.blocking_modes) {
			this.setValue(mode, "off");
		}
		this.setValue('ai_mode', 'heating');
		this.setValue('ai_mode_dhw', 'AICI_ON_NORMAL');
		this.setValue('ai_mode_heating', 'AICI_ON_NORMAL');
		this.setValue('wizard_help_shown', 'false');
		this.setValue('greeniq', 'AICI_ON_NORMAL');
		this.setValue('comfortmode', 'AICI_ON_NORMAL');
		this.setValue('ecomode', 'AICI_ON_NORMAL');
		this.setValue('heizmodus', 'Zeitgesteuert');
		this.setValue('warmwassermodus', 'DELIGHT_ZONE_MODE_SELECTION_ENTRY_MANUAL');
		this.setValue('lueftungsmodus', 'DELIGHT_ZONE_MODE_SELECTION_ENTRY_AUTO');
		this.setValue('kuehlmodus', 'DELIGHT_ZONE_MODE_SELECTION_ENTRY_AUTO');
		this.setValue('waermerueckgewinnung', 'DELIGHT_DIA_REPLACE_TEXT_AUTO');
		this.setValue('feuchteschutz', 'Auto');
		this.setValue('remote_connected', 'unset');
		this.setValue('brenner', 'ENUM_BURNER_STATE_OFF');
		this.setValue('sommerzeit', 'AICI_ON_NORMAL');
		this.setValue('stromtariftyp', 'ENUM_ELECTRICITY_TARIFF_TYPE_VARIABLE');
		this.setValue('adaptiveHeatingCurve', 'DELIGHT_DIA_CODE_EMM_ID_092_VALUE_0');
		this.setValue('automatic_cooling', 'DELIGHT_DIA_CODE_EMM_ID_092_VALUE_0');
		this.setValue('source_regeneration', 'AICI_NO_NORMAL');
		this.setValue('hybridmanager', 'ENUM_HYBRID_MANAGER_BIVALENCEPOINT');
		this.setValue('evu', 'DELIGHT_DIA_CODE_EMM_ID_084_VALUE_0')
		this.setValue('zusatzheizgeraet_modus', 'DELIGHT_DIA_CODE_EMM_ID_103_VALUE_3');
		this.setValue('zusatzheizgeraet_typ', 'ENUM_AUXILIARY_HEATER_TYPE_CONDENSING');
		this.setValue('ext_inputs', 'ENUM_CONFIGURATION_OF_DEMAND_INPUTS_DISABLE_BY_SHORT_CIRCUIT');
		this.setValue('ansteuerumkehr', 'ENUM_ACTUATION_REVERSAL_ON');
		this.setValue('configuration_ma_vr70', 'ENUM_MAVR70_NO_FUNCTION');
		this.setValue('configuration_ma_vr71', 'ENUM_MAVR71_NO_FUNCTION');
		this.setValue('configuration_ma2', 'ENUM_HP_MODUL_OUTPUT_2_DHW_CIRCULATION_PUMP');
		this.setValue('configuration_me', 'DELIGHT_DIA_CODE_EMM_ID_085_VALUE_1');
		this.setValue('configuration_wp_ma2', 'ENUM_HP_MODUL_OUTPUT_2_DHW_CIRCULATION_PUMP');
		this.setValue('configuration_wp_me', 'DELIGHT_DIA_CODE_EMM_ID_085_VALUE_1');

		this.setValue('configuration_wp_regelungsmodul', 'ENUM_DELIGHT_SYSTEM_CONFIG_MENU_ENTRY_STATUS_STANDBY');
		this.setValue('buttonlock', 'off');
		this.setValue('systemState', 'ENUM_DELIGHT_SYSTEM_CONFIG_MENU_ENTRY_STATUS_HEATING');
		// wizard...
		this.setValue('wizard_solar_option', 'WIZARD_SOLAR_OPTIONS_ENUM1');
		this.setValue('wizard_zone_option', 'WIZARD_ZONE_OPTIONS_ENUM1');
		this.setValue('wizard_mavr70_options', 'WIZARD_MA_VR70_OPTIONS_ENUM1');
		this.setValue('wizard_vwz_options', 'WIZARD_VWZ_OPTIONS_ENUM1');

		let absenkModus = new BaseSensor();
		absenkModus.setUnit('');
		absenkModus.setCurrentValue(0);
		absenkModus.setList(['DELIGHT_DIA_CODE_EMM_ID_057_VALUE_0', 'DELIGHT_DIA_CODE_EMM_ID_057_VALUE_1']);
		absenkModus.setName('absenkModus');
		this.scales.set('absenkModus', absenkModus);

		this.setScale('2hk_installed', new BaseSensor().setList(['AICI_NO_NORMAL','AICI_YES_NORMAL']));

		let lst = new BaseSensor();
		lst.setUnit('');
		lst.setList(['DELIGHT_DIA_CODE_EMM_ID_049_VALUE_0', 'DELIGHT_DIA_CODE_EMM_ID_049_VALUE_1', 'DELIGHT_DIA_CODE_EMM_ID_049_VALUE_2', 'DELIGHT_DIA_CODE_EMM_ID_049_VALUE_3', 'DELIGHT_DIA_CODE_EMM_ID_049_VALUE_4', 'DELIGHT_DIA_CODE_EMM_ID_049_VALUE_5', 'DELIGHT_DIA_CODE_EMM_ID_049_VALUE_6', 'DELIGHT_DIA_CODE_EMM_ID_049_VALUE_7', 'DELIGHT_DIA_CODE_EMM_ID_049_VALUE_8']);
		this.scales.set('warmwasser_legionellenschutz_tag', lst);

		this.mainZoneId = 1;
		this.setValue('powerstate', 'on');
		this.scales.set('waterpressure', BaseSensor.fromArgs("waterpressure", 1.5, 0, 3, 0.1, "AICI_UNIT_BAR"));
		this.scales.set("connectionQualityVRC720", BaseSensor.fromArgs("connectionQualityVRC720", 10, 0, 10, 1, " "));
		this.scales.set("connectionQualityATSensor", BaseSensor.fromArgs("connectionQualityVRC720", 10, 0, 10, 1, " "));
		this.scales.set("brightness", BaseSensor.fromArgs("brightness", 10, 0, 10, 1, " "));
		this.scales.set("zusatztarif", BaseSensor.fromArgs("zusatztarif", 12, 1, 999, 1, ""));
		this.scales.set("eintarif", BaseSensor.fromArgs("eintarif", 20, 1, 999, 1, ""));
		this.scales.set("hochtarif", BaseSensor.fromArgs("hochtarif", 20, 1, 999, 1, ""));
		this.scales.set("niedertarif", BaseSensor.fromArgs("niedertarif", 16, 1, 999, 1, ""));
		this.scales.set("code", BaseSensor.fromArgs("code", 0, 0, 99, 1, ""));
		this.scales.set("automatic_cooling_temperature_outside", BaseSensor.fromArgs("automatic_cooling_temperature_outside", 15, 10, 30, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("dew_point", BaseSensor.fromArgs("dew_point", -30, 4, 30, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("bivalence_point_water", BaseSensor.fromArgs("bivalence_point_water", -7, -20, 20, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("bivalence_point_heating", BaseSensor.fromArgs("bivalence_point_heating", 0, -20, 30, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("alternative_point", BaseSensor.fromArgs("alternative_point", -21, -21, 40, 1, "AICI_UNIT_CELSIUS"));
		this.scales.get('alternative_point').setSpecialValue(-21, "AICI_OFF_NORMAL");
		this.scales.set("temperature_emergency_run", BaseSensor.fromArgs("temperature_emergency_run", 25, 20, 80, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("inlet_temperature", BaseSensor.fromArgs("inlet_temperature", 35, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("offset_bufferstorage", BaseSensor.fromArgs("offset_bufferstorage", 10, 0, 15, 1, "AICI_UNIT_KELVIN"));
		this.scales.set("systemschema_code", BaseSensor.fromArgs("systemschema_code", 8, 1, 16, 1, ""));
		this.scales.set("configuration_vr70", BaseSensor.fromArgs("configuration_vr70", 1, 1, 12, 1, ""));
		this.scales.set("configuration_vr71", BaseSensor.fromArgs("configuration_vr71", 1, 1, 11, 1, ""));


		this.scales.set('platzhalter', BaseSensor.fromArgs('platzhalter', 1, 1, 10, 1, '.'));

		/**
			Test-Programme
		**/
		this.scales.set('adjustablePowerLoad', BaseSensor.fromArgs('adjustablePowerLoad', 25, 25, 50, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('adjustablePowerLoad2', BaseSensor.fromArgs('adjustablePowerLoad2', 25, 25, 50, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('adjustablePowerLoad3', BaseSensor.fromArgs('adjustablePowerLoad3', 7, 7, 20, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('maxHeatLoad', BaseSensor.fromArgs('maxHeatLoad', 50, 1, 99, 1, "AICI_UNIT_CELSIUS"));

		/* 2Kreis-Installation */
		this.scales.set("max_heat_requirement_hc1", BaseSensor.fromArgs("max_heat_requirement_hc1", 0, 0, 25, 0.5, "AICI_UNIT_KW"));
		this.scales.set("target_spread_hc1", BaseSensor.fromArgs("target_spread_hc1", 5, 5, 20, 1, "AICI_UNIT_KELVIN"));
		this.scales.get('target_spread_hc1').registerHook('valueChanged',(v:any)=>{
			console.trace({msg:"value changed",newValue:v});
		});
		this.scales.set("target_spread_system", BaseSensor.fromArgs("target_spread_system", 5, 5, 8, 1, "AICI_UNIT_KELVIN"));
		/**

				Aktuator-Tests.
		**/
		this.scales.set('internalPump', BaseSensor.fromArgs('internalPump', 100, 100, 400, 10, "AICI_UNIT_MBAR"));
		// DELIGHT_DATAOVERVIEW_3WAY_VALVE_HEATING | DELIGHT_DATAOVERVIEW_3WAY_VALVE_HOTWATER | DELIGHT_DATAOVERVIEW_3WAY_VALVE_MIDDLE
		this.setScale('threewayValveState', (new BaseSensor()).setList(['DELIGHT_DATAOVERVIEW_3WAY_VALVE_HEATING', 'DELIGHT_DATAOVERVIEW_3WAY_VALVE_HOTWATER', 'DELIGHT_DATAOVERVIEW_3WAY_VALVE_MIDDLE']));
		let fanSpeeds = [];
		for (let i = 0; i <= 116; i++) {
			fanSpeeds.push((i * 100).toString());
		}
		fanSpeeds.push("11640");
		this.scales.set('fanSpeed', (new BaseSensor()).setList(fanSpeeds).setUnit('AICI_UNIT_ROTATIONSPERMINUTE'));
		// ENUM_ACTUATION_REVERSAL_ON | ENUM_ACTUATION_REVERSAL_OFF
		this.setValue('tankLoadPumpState', 'ENUM_ACTUATION_REVERSAL_OFF');

		this.scales.set('burnerMinModulation', BaseSensor.fromArgs('burnerMinModulation', 50, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		let notbetrieb = new BaseSensor();
		notbetrieb.setList(['AICI_YES_NORMAL', 'AICI_NO_NORMAL']);
		notbetrieb.setUnit('');
		this.setScale('notbetrieb', notbetrieb);
		// 3.5.13
		this.scales.set("buffertemperature_top", BaseSensor.fromArgs("buffertemperature_top", 12, 1, 12, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("buffertemperature_bottom", BaseSensor.fromArgs("buffertemperature_bottom", 12, 1, 12, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("temp_sensor_ww_top", BaseSensor.fromArgs("temp_sensor_ww_top", 12, 1, 12, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("temp_sensor_ww_bottom", BaseSensor.fromArgs("temp_sensor_ww_bottom", 12, 1, 12, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("temp_sensor_hz_bottom", BaseSensor.fromArgs("temp_sensor_hz_bottom", 12, 1, 12, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("temp_sensor_hz_top", BaseSensor.fromArgs("temp_sensor_hz_top", 12, 1, 12, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("solar_buffer_count", BaseSensor.fromArgs("solar_buffer_count", 1, 1, 2, 1, ""));
		this.scales.set("solarbuffer_1_bottom", BaseSensor.fromArgs("solarbuffer_1_bottom", 12, 1, 12, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("solarbuffer_2_bottom", BaseSensor.fromArgs("solarbuffer_2_bottom", 12, 1, 12, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("max_ww_inlet_nominal", BaseSensor.fromArgs("max_ww_inlet_nominal", 80, 45, 80, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("max_temp_buffer_1", BaseSensor.fromArgs("max_temp_buffer_1", 75, 0, 99, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("max_temp_buffer_2", BaseSensor.fromArgs("max_temp_buffer_2", 75, 0, 99, 1, "AICI_UNIT_CELSIUS"));

		//3.5.14
		this.scales.set("solar_collector_temperature", BaseSensor.fromArgs("solar_collector_temperature", 85, 0, 200, 1, "AICI_UNIT_CELSIUS"));
		this.setValue('solar_pump_state', 'ENUM_SOLAR_PUMP_STATUS_OFF');
		this.setValue('solar_pump_kick', 'ENUM_COLLECTOR_KICK_FUNCTION_ON');
		this.scales.set("solar_gain", BaseSensor.fromArgs("solar_gain", 78, 0, 200, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("solar_throughput", BaseSensor.fromArgs("solar_throughput", 0.0, 0.0, 165, 0.1, "AICI_UNIT_LITER_PRO_MINUTE"));
		this.scales.get("solar_throughput").setSpecialValue(0.0, "DELIGHT_DIA_REPLACE_TEXT_AUTO");
		this.scales.set("solar_protection", BaseSensor.fromArgs("solar_protection", 130, 110, 150, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("solar_min_collector_temp", BaseSensor.fromArgs("solar_min_collector_temp", 20, 0, 99, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("solar_ventilation_time", BaseSensor.fromArgs("solar_ventilation_time", 0, 0, 600, 1, "AICI_UNIT_MINUTES"));
		this.scales.set("solar_current_throughput", BaseSensor.fromArgs("solar_current_throughput", 0, 0, 16.5, 0.1, "AICI_UNIT_LITER_PRO_MINUTE"));
		this.scales.set("solarbuffer_1_einschaltdifferenz", BaseSensor.fromArgs("solarbuffer_1_einschaltdifferenz", 12, 2, 25, 1, "AICI_UNIT_KELVIN"));
		this.scales.set("solarbuffer_2_einschaltdifferenz", BaseSensor.fromArgs("solarbuffer_2_einschaltdifferenz", 12, 2, 25, 1, "AICI_UNIT_KELVIN"));
		this.scales.set("solarbuffer_1_ausschaltdifferenz", BaseSensor.fromArgs("solarbuffer_1_ausschaltdifferenz", 5, 1, 20, 1, "AICI_UNIT_KELVIN"));
		this.scales.set("solarbuffer_2_ausschaltdifferenz", BaseSensor.fromArgs("solarbuffer_2_ausschaltdifferenz", 5, 1, 20, 1, "AICI_UNIT_KELVIN"));
		this.scales.set("solarbuffer_1_max_temp", BaseSensor.fromArgs("solarbuffer_1_max_temp", 75, 0, 99, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("solarbuffer_2_max_temp", BaseSensor.fromArgs("solarbuffer_2_max_temp", 75, 0, 99, 1, "AICI_UNIT_CELSIUS"));

		// 3.5.16
		this.scales.set("td_regelung_einschaltdifferenz", BaseSensor.fromArgs("td_regelung_einschaltdifferenz", 12, 2, 25, 1, "AICI_UNIT_KELVIN"));
		this.scales.set("td_regelung_ausschaltdifferenz", BaseSensor.fromArgs("td_regelung_ausschaltdifferenz", 5, 1, 20, 1, "AICI_UNIT_KELVIN"));

		this.scales.set("td_regelung_min_temp", BaseSensor.fromArgs("td_regelung_min_temp", 0, 0, 99, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("td_regelung_max_temp", BaseSensor.fromArgs("td_regelung_max_temp", 99, 0, 99, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("td_sensor_1", BaseSensor.fromArgs("td_sensor_1", 66, 0, 99, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set("td_sensor_2", BaseSensor.fromArgs("td_sensor_2", 72, 0, 99, 1, "AICI_UNIT_CELSIUS"));
		this.setValue('td_ausgang', 'ENUM_TD_OUTPUT_OFF');

		//...
		this.scales.set('estrichttrocknung-tag-0', BaseSensor.fromArgs('estrichttrocknung-tag-0', 0, 0, 0, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-1', BaseSensor.fromArgs('estrichttrocknung-tag-1', 25, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-2', BaseSensor.fromArgs('estrichttrocknung-tag-2', 30, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-3', BaseSensor.fromArgs('estrichttrocknung-tag-3', 35, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-4', BaseSensor.fromArgs('estrichttrocknung-tag-4', 40, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-5', BaseSensor.fromArgs('estrichttrocknung-tag-5', 45, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-6', BaseSensor.fromArgs('estrichttrocknung-tag-6', 45, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-7', BaseSensor.fromArgs('estrichttrocknung-tag-7', 45, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-8', BaseSensor.fromArgs('estrichttrocknung-tag-8', 45, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-9', BaseSensor.fromArgs('estrichttrocknung-tag-9', 45, 0, 90, 1, "AICI_UNIT_CELSIUS"));

		this.scales.set('estrichttrocknung-tag-10', BaseSensor.fromArgs('estrichttrocknung-tag-10', 45, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-11', BaseSensor.fromArgs('estrichttrocknung-tag-11', 45, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-12', BaseSensor.fromArgs('estrichttrocknung-tag-12', 45, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-13', BaseSensor.fromArgs('estrichttrocknung-tag-13', 40, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-14', BaseSensor.fromArgs('estrichttrocknung-tag-14', 35, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-15', BaseSensor.fromArgs('estrichttrocknung-tag-15', 25, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-16', BaseSensor.fromArgs('estrichttrocknung-tag-16', 25, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-17', BaseSensor.fromArgs('estrichttrocknung-tag-17', 10, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-18', BaseSensor.fromArgs('estrichttrocknung-tag-18', 10, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-19', BaseSensor.fromArgs('estrichttrocknung-tag-19', 10, 0, 90, 1, "AICI_UNIT_CELSIUS"));

		this.scales.set('estrichttrocknung-tag-20', BaseSensor.fromArgs('estrichttrocknung-tag-20', 10, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-21', BaseSensor.fromArgs('estrichttrocknung-tag-21', 10, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-22', BaseSensor.fromArgs('estrichttrocknung-tag-22', 10, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-23', BaseSensor.fromArgs('estrichttrocknung-tag-23', 10, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-24', BaseSensor.fromArgs('estrichttrocknung-tag-24', 30, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-25', BaseSensor.fromArgs('estrichttrocknung-tag-25', 35, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-26', BaseSensor.fromArgs('estrichttrocknung-tag-26', 40, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-27', BaseSensor.fromArgs('estrichttrocknung-tag-27', 45, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-28', BaseSensor.fromArgs('estrichttrocknung-tag-28', 35, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('estrichttrocknung-tag-29', BaseSensor.fromArgs('estrichttrocknung-tag-29', 25, 0, 90, 1, "AICI_UNIT_CELSIUS"));

		this.values.set('actortest_actor', 'Kein Aktor');
		this.scales.set('s1', BaseSensor.fromArgs('s1', 59, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('s2', BaseSensor.fromArgs('s2', 55, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('s3', BaseSensor.fromArgs('s3', 48, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('s4', BaseSensor.fromArgs('s4', 45, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('s5', BaseSensor.fromArgs('s5', 53, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('s6', BaseSensor.fromArgs('s6', 42, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('s7', BaseSensor.fromArgs('s7', 51, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('s8', BaseSensor.fromArgs('s8', 43, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('s9', BaseSensor.fromArgs('s9', 47, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('s10', BaseSensor.fromArgs('s10', 43, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.scales.set('s11', BaseSensor.fromArgs('s11', 50, 0, 90, 1, "AICI_UNIT_CELSIUS"));
		this.setZoneCount(3);
		this.setHeatingCircuitCount(3);
	}
	simulatorConfig: SimulatorConfig;
	setSimulatorConfig(sc: SimulatorConfig) {
		this._hooks.setSimulatorConfig(sc);
		this.simulatorConfig = sc;
		let maxHeatingCircuitCount = 9;
		if (this.simulatorConfig.getVR71Count() == 1 && this.simulatorConfig.getVR70Count() == 0) {
			maxHeatingCircuitCount = 3;
		}
		if (this.simulatorConfig.getVR71Count() == 1 && this.simulatorConfig.getVR70Count() == 1) {
			maxHeatingCircuitCount = 5;
		}
		if (this.simulatorConfig.getVR71Count() == 1 && this.simulatorConfig.getVR70Count() == 2) {
			maxHeatingCircuitCount = 7;
		}
		if (this.simulatorConfig.getVR71Count() == 1 && this.simulatorConfig.getVR70Count() == 3) {
			maxHeatingCircuitCount = 9;
		}
		if (this.simulatorConfig.getVR70Count() == 1 && this.simulatorConfig.getVR71Count() == 0) {
			maxHeatingCircuitCount = 2;
		}

		this.scales.set("wizard_heatingcircuit_count", BaseSensor.fromArgs("wizard_heatingcircuit_count", 1, 1, maxHeatingCircuitCount, 1, ""));

	}
	getSimulatorConfig() {
		return this.simulatorConfig;
	}
	mainZoneId: number = 1;
	getDefinedBlockingStates() {
		return this.blocking_modes;
	}
	isInBlockingMode() {
		for (let m of this.blocking_modes) {
			if (this.getValue(m) == "on") {
				return true;
			}
		}
		return false;
	}

	getBlockingStates(): Array<string> {
		let states = new Array<string>();
		for (let m of this.blocking_modes) {
			if (this.getValue(m) == "on") {
				states.push(m);
			}
		}

		return states;
	}

	reset() {
		this.disableBlockingStates();
	}
	public disableBlockingStates(): void {
		for (let m of this.blocking_modes) {
			this.setValue(m, "off");
		}
	}
	blocking_modes = ['cylinder_boost', 'ventilation_boost', 'continuous_cooling', 'system_off', 'absence'];

	getDeviceList(): Array<KeyValuePair> {
		let list = Array<KeyValuePair>()
		list.push(new KeyValuePair('Regler', '01.18'));
		list.push(new KeyValuePair('Wärmepumpe', '03.04'));
		list.push(new KeyValuePair('WP-Regelungsmodul', '03.04'));
		list.push(new KeyValuePair('VR70, Adresse 1', '01.06'));
		return list;
	}

	setHeatpumpCount(val: number): void {

		for (let i = 0; i < this.heatpumpCount; i++) {
			let idx = "heatpump-inlet-temperature-" + (i + 1).toString();
			this.scales.delete(idx);
		}
		this.heatpumpCount = val;

		for (let i = 0; i < this.heatpumpCount; i++) {
			let idx = "heatpump-inlet-temperature-" + (i + 1).toString();
			this.scales.set(idx, BaseSensor.fromArgs("idx", 55, 0, 80, 1, "AICI_UNIT_CELSIUS"));
			this.debug("Adding status: " + 'heatpump-' + (i + 1).toString() + '-mode');
			this.setValue('heatpump-' + (i + 1).toString() + '-mode', 'ENUM_DELIGHT_SYSTEM_CONFIG_MENU_ENTRY_STATUS_STANDBY');
		}
	}
	setBoilerCount(val: number) {
		for (let i = 0; i < this.heatpumpCount; i++) {
			let idx = "boiler-inlet-temperature-" + (i + 1).toString();
			this.scales.delete(idx);
		}
		this.heatpumpCount = val;

		for (let i = 0; i < this.heatpumpCount; i++) {
			let idx = "boiler-inlet-temperature-" + (i + 1).toString();
			this.scales.set(idx, BaseSensor.fromArgs("idx", 55, 0, 80, 1, "AICI_UNIT_CELSIUS"));
			this.debug("Adding status: " + 'boiler-' + (i + 1).toString() + '-mode');
			this.setValue('boiler-' + (i + 1).toString() + '-mode', 'ENUM_DELIGHT_SYSTEM_CONFIG_MENU_ENTRY_STATUS_STANDBY');
		}
	}
	getConfiguredHeatpumpCount() {
		if (!this.simulatorConfig) {
			this.debug("configured HEATPUMPS: 0");
			return 0;
		}
		this.debug("configured HEATPUMPS: " + this.simulatorConfig.heatpumpCount());
		return this.simulatorConfig.heatpumpCount();
	}
	getConfiguredBoilerCount() {
		if (!this.simulatorConfig) {
			return 0;
		}
		return this.simulatorConfig.boilerCount();

	}
	getHeatpumpCount(): number {
		return this.heatpumpCount;
	}
	getHeatingCircuit(idx: number): HeatingCircuit {
		return this.heatingCircuits[idx];
	}
	getDefaultHeatingCircuit() {
		return this.getHeatingCircuitById(this.defaultZone);
	}
	getHeatingCircuitById(id: number) {

		for (let hc of this.heatingCircuits) {
			if (hc.getId() == id) {

				return hc;
			} else {
				//console.log("not returning hc "+hc.getId() );
			}
		}
		return null;
	}
	getBoilerCount() {
		if (!this.simulatorConfig) {
			return 0;
		}
		return this.simulatorConfig.boilerCount();
	}
	getHeatGeneratorCount() {
		if (!this.simulatorConfig) {
			return 0;
		}
		let hcc = this.simulatorConfig.heatpumpCount();
		let bc = this.simulatorConfig.boilerCount();
		if (bc > hcc) {
			this.debug("Heat generators: " + bc);
			return bc;
		} else {
			this.debug("Heat generators: " + hcc);
			return hcc;
		}
	}
	getHeatingCircuits(): Array<HeatingCircuit> {
		return this.heatingCircuits;
	}
	getHeatingCircuitCount() {
		return this.heatingCircuits.length;
	}

	getNominalTemperatureSensor(date: Date): ISensorInterface {
		let zone = this.getDefaultZone();
		if (zone.getRawValue('quickset-temperature-enabled') == 'on') {
			return zone.getSensor('temperature', 'room_temperature_nominal_quick');
		}
		switch (zone.getRawValue('heatingmode')) {
			case 'ENUM_HEATING_MODE_OFF': {
				return null;
			}
			case 'DELIGHT_ZONE_MODE_SELECTION_ENTRY_MANUAL': {
				return zone.getSensor('temperature', 'room_temperature_nominal');
			}
			case 'DELIGHT_ZONE_MODE_SELECTION_ENTRY_AUTO': {
				let timeframeManager = zone.getTimeFrameManager('heating');
				if (!timeframeManager) {
					this.debug("cannot get timeframe-manager.");
					return;
				}
				let day = date.getDay();

				if (day == 0) {
					day = 6;
				} else {
					day = day - 1;
				}
				this.debug("Asking for day:" + day);
				let timeframe = timeframeManager.getTimeFrame(day, date);
				if (!timeframe) {
					this.debug("cannot get timeframe");
					return;
				}
				let sensor = timeframe.getSensor();
				if (!sensor) {
					this.debug("cannot get sensor.");
				}
				this.debug("Found Timeframe sensor: " + timeframe.toString());
				return sensor;
			}
			default: {
				return zone.getSensor('temperature', 'room_temperature_nominal');
			}
		}


	}
	setHeatingCircuitCount(val: number) {
		this.heatingCircuits.length = 0;
		for (let i = 0; i < val; i++) {
			this.heatingCircuits.push(new HeatingCircuit(i + 1));
		}

		//this.getScale('wizard_heatingcircuit_count').setCurrentValue(val);
	}


	getHeatingCircuitIds(): Array<number> {

		let ids = [];
		for (let hc of this.heatingCircuits) {
			ids.push(hc.getId());
		}
		return ids;
	}



	setZoneCount(zc: number) {
		this.zoneData.length = 0;
		let activeHeatingCircuitCount = zc;
		if (!this.simulatorConfig) {
			return;
		}
		if (this.simulatorConfig) {
			console.log("Overwriting activeHeatingCircuitCount with " + this.simulatorConfig.activeHeatingCircuits());
			activeHeatingCircuitCount = this.simulatorConfig.activeHeatingCircuits();
		}


		//Zuordnungen / Fernbedienungen

		if (this.simulatorConfig.hasVR71()) {
			for (let i = 1; i <= zc; i++) {
				let zd = new ZoneData(TranslationService.getInstance().tr("DELIGHT_ZONE_MENU_ENTRY_ZONE_NAME") + " " + i, i);
				if (i <= 5) {
					if (i < zc && i < 5) {
						zd.setValue('zone_assignment', 'ENUM_ZONE_BINDING_REMOTE_CONTROL_' + i.toString());
					}

					if (i == activeHeatingCircuitCount) {
						zd.setValue('zone_assignment', 'ENUM_ZONE_BINDING_CENTRAL_CONTROL');
					}

				}
				if (i > 5 || i > activeHeatingCircuitCount) {
					zd.setValue('zone_assignment', 'ENUM_ZONE_BINDING_NO');
				}

				this.zoneData.push(zd);

			}
		} else {
			for (let i = 1; i <= zc; i++) {
				let zd = new ZoneData(TranslationService.getInstance().tr("DELIGHT_ZONE_MENU_ENTRY_ZONE_NAME") + " " + i, i);
				if (i == 1) {
					zd.setValue('zone_assignment', 'ENUM_ZONE_BINDING_CENTRAL_CONTROL');
				} else {
					zd.setValue('zone_assignment', 'ENUM_ZONE_BINDING_NO');
				}
				this.zoneData.push(zd);
			}
		}

		if (this.defaultZone == undefined) {
			this.defaultZone = 1;
		}
	}


	getZoneCount(): number {
		return this.zoneData.length;
	}
	getDefaultZoneId(): number {
		return this.defaultZone;
	}
	setDefaultZoneId(val: number): void {
		this.defaultZone = val;
	}
	getDefaultZone(): ZoneData {
		return this.getZoneById(this.defaultZone);
	}
	getZone(): ZoneData {
		return this.getZoneById(this.defaultZone);
	}
	getZoneById(id: number): ZoneData {

		for (let zd of this.zoneData) {
			if (zd.getId() == id) {
				return zd;
			} else {
			}
		}
	}



	getZoneByIndex(zone: number): ZoneData {
		return this.zoneData[zone];
	}

	getZoneIds() {
		this.debug("Getting Zone-IDs");
		let ids = [];
		for (let zone of this.zoneData) {
			ids.push(zone.getId());
		}
		this.debug(JSON.stringify(ids));
		return ids;
	}
	getVR71Count() {
		return this.simulatorConfig.getVR71Count();
	}
	getVR70Count() {
		return this.simulatorConfig.getVR70Count();
	}


	getHooks() {
		return this._hooks;
	}


	system_scheme(): number {
		return this.scales.get('systemschema_code').getCurrentValue();
	}
	vr70(): number {
		return this.scales.get("configuration_vr70").getCurrentValue();
	}
	vr71(): number {
		return this.scales.get("configuration_vr71").getCurrentValue();
	}
}

